module.exports = __webpack_public_path__ + "static/fimg3-ecc40bd1b34bc255062e995ff1a95963.svg";